/* eslint-disable @typescript-eslint/naming-convention */
import { getServerSession } from "next-auth";
import { type SubCheckoutPageV2Props } from "~/components/SubCheckoutV2/SubCheckoutPage";
import { authOptions } from "~/lib/server/auth";
import { wrapGetServerSideProps } from "~/lib/server/wrapGetProps";
import { getServerSidePropsFromUserInfo } from "~/pages/subscription-checkout-v2";
import { SubscriptionCheckoutNextPage } from "./subscription-checkout.client";

export const getServerSideProps =
  wrapGetServerSideProps<SubCheckoutPageV2Props>(
    async ({ query, req, res }) => {
      const session = await getServerSession(req, res, authOptions);
      const subscriptionName =
        typeof query.subscription === "string"
          ? query.subscription.toLowerCase()
          : "";

      const props = await getServerSidePropsFromUserInfo(
        session,
        subscriptionName
      );

      return {
        props: {
          ...props,
          meta: { piano: { type: "simple" } },
        },
      };
    }
  );

export default SubscriptionCheckoutNextPage;
